import React, { useState } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "./style.scss";
import * as Yup from "yup";
import { useFormik } from "formik";
import { LANG } from "../../../constants/language";
import { changePassword } from "../../../services/user.service";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

const ProfileChangePassword: React.FC = () => {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();

  const [isOldPasswordVisible, setIsOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

  const initialValues = {
    old_password: "",
    new_password: "",
    confirm_password: "",
  }

  const validationSchema = Yup.object().shape({
    old_password: Yup.string().required("Old password is required"),
    new_password: Yup.string()
      .required("New password is required")
      .min(8, LANG.PASSWORD_MIN_LENGTH)
      .matches(/[A-Z]/, LANG.PASSWORD_UPPERCASE)
      .matches(/[a-z]/, LANG.PASSWORD_LOWERCASE)
      .matches(/[0-9]/, LANG.PASSWORD_NUMBER)
      .matches(/[@#%!-]/, LANG.PASSWORD_SYMBOL),
    confirm_password: Yup.string()
      .required(LANG.CONFIRM_PASSWORD_IS_REQUIRED)
      .oneOf([Yup.ref("new_password")], LANG.PASSWORDS_MUST_MATCH),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnBlur: true,

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        let payload = {
          old_password: values.old_password,
          new_password: values.new_password
        }
        const result: any = await changePassword(payload);
        if (result) {
          toast.success(result.data.message || "Password changed successfully");
          resetForm();
        }
      } catch (error) {
        console.log(error);
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.error)
        }
        setSubmitting(false);
      }
    },
  });


  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content mb-5">
        <div className="profileSettings profile-change-password">
          <h2 className="mb-4">Update your password</h2>
          <div className="title_form">

            <form className="account-form" onSubmit={formik.handleSubmit}>
              <div className="form-group mb-2">
                <label>Enter your old Password</label>
                <div className="pass-group group-img">
                  <input
                    name="old_password"
                    id="old_password"
                    type={isOldPasswordVisible ? "text" : "password"}
                    placeholder="Enter your old Password"
                    value={formik.values.old_password}
                    onChange={formik.handleChange}
                    className={`form-control commonInput pass-confirm ${formik.touched.old_password && formik.errors.old_password ? "is-invalid" : ""}`}
                  />

                  <i
                    className={`toggle-password ${isOldPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                    onClick={() => setIsOldPasswordVisible(!isOldPasswordVisible)}
                  />

                  {formik.touched.old_password && formik.errors.old_password && (
                    <div className="invalid-feedback">
                      {formik.errors.old_password}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group mb-2">
                <label>New Password</label>
                <div className="pass-group group-img">
                  <input
                    name="new_password"
                    id="new_password"
                    type={isNewPasswordVisible ? "text" : "password"}
                    placeholder="Enter your new password"
                    value={formik.values.new_password}
                    onChange={formik.handleChange}
                    className={`form-control commonInput pass-confirm ${formik.touched.new_password && formik.errors.new_password ? "is-invalid" : ""}`}
                  />
                  <i
                    className={`toggle-password ${isNewPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                    onClick={() => setIsNewPasswordVisible(!isNewPasswordVisible)}
                  />

                  {formik.touched.new_password && formik.errors.new_password && (
                    <div className="invalid-feedback">
                      {formik.errors.new_password}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group mb-2">
                <label>New Password Confirm</label>
                <div className="pass-group group-img">
                  <input
                    name="confirm_password"
                    id="confirm_password"
                    type={isConfirmPasswordVisible ? "text" : "password"}
                    placeholder="Enter your confirm password"
                    value={formik.values.confirm_password}
                    onChange={formik.handleChange}
                    className={`form-control commonInput pass-confirm ${formik.touched.confirm_password && formik.errors.confirm_password ? "is-invalid" : ""}`}
                  />

                  <i
                    className={`toggle-password ${isConfirmPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                    onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                  />

                  {formik.touched.confirm_password && formik.errors.confirm_password && (
                    <div className="invalid-feedback">
                      {formik.errors.confirm_password}
                    </div>
                  )}
                </div>
              </div>

              <button type="submit" className="btn-update">
                Update Password
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfileChangePassword;
